import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";

export const YoutubeVideoEdit = () => {
  return (
    <Edit>
      <SimpleForm>
        <BooleanInput source="isActive" />
        <TextInput source="title" />
        <TextInput source="thumbnailUrl" />
        <TextInput source="youtubeUrl" />
      </SimpleForm>
    </Edit>
  );
};
